import { createContext, useContext, useState, useEffect } from "react";

const SectionClockContext = createContext(null);

export const SectionClockProvider = ({ children }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <SectionClockContext.Provider value={now}>
      {children}
    </SectionClockContext.Provider>
  );
};

// Falls back to a static Date.now() when used outside the provider
// so SectionDurationBadge still renders correctly (just won't tick live)
export const useSectionClock = () =>
  useContext(SectionClockContext) ?? Date.now();
